// preserve reference to original console
const __console = globalThis.console

// future logger instance getter
let __getLogger: () => Console | undefined = () => undefined

// mock console with logger
// each synchronous call will be postponed until the logger is available, then executed with the same arguments
globalThis.console = new Proxy(console, {
  get(target, prop) {
    const original = Reflect.get(target, prop)
    if (typeof original === 'function') {
      let tryCount = 0
      return function postpone(...args: unknown[]) {
        Promise.resolve().then(() => {
          const logger = __getLogger()
          if (logger) {
            logger[prop](...args)
          } else {
            if (tryCount++ < 3) postpone(...args) // try again later
          }
        })
      }
    }
    return original
  },
})

// update logger getter to use our logger and restore original console
export function replaceLogger(getLogger: () => Console) {
  __getLogger = getLogger
  globalThis.console = __console
}
